import { render, staticRenderFns } from "./AddStockDetailDialog.vue?vue&type=template&id=281c6f68&"
import script from "./AddStockDetailDialog.vue?vue&type=script&lang=js&"
export * from "./AddStockDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports